import { Instagram } from "lucide-react";
import { MaskReveal, Reveal } from "./Reveal";
import { InstagramEmbed } from "./InstagramEmbed";
import { GALLERY, BUSINESS } from "./data";

export const Gallery = () => {
  return (
    <section id="gallery" className="relative bg-ink-900 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="mb-16 flex flex-col justify-between gap-6 md:mb-20 md:flex-row md:items-end">
          <div>
            <Reveal>
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ On Instagram</span>
            </Reveal>
            <h2 className="mt-5 font-oswald text-6xl font-700 uppercase leading-[0.85] tracking-tighter text-white md:text-8xl">
              <MaskReveal lines={["The", "Feed"]} />
            </h2>
          </div>
          <Reveal delay={0.2}>
            <a
              data-testid="instagram-follow-btn"
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3.5 hover:border-gold transition-colors duration-500"
            >
              <Instagram size={16} className="text-white group-hover:text-gold transition-colors duration-500" />
              <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white group-hover:text-gold transition-colors duration-500">
                @_jazzythegreat_
              </span>
            </a>
          </Reveal>
        </div>

        <div className="grid auto-rows-[180px] grid-cols-2 gap-4 md:auto-rows-[280px] md:grid-cols-4 md:gap-6">
          {GALLERY.map((item, i) => (
            <a
              key={i}
              data-testid={`gallery-item-${i}`}
              href={BUSINESS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className={`group relative block overflow-hidden ${item.span}`}
            >
              <img
                src={item.img}
                alt={item.cap}
                className="h-full w-full object-cover grayscale transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105 group-hover:grayscale-0"
              />
              <div className="absolute inset-0 bg-ink-950/40 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <div className="absolute bottom-0 left-0 flex translate-y-3 items-center gap-2 p-4 opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <Instagram size={14} className="text-gold" />
                <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white">{item.cap}</span>
              </div>
            </a>
          ))}
        </div>

        {/* Live Instagram profile embed */}
        <div className="mt-16 grid gap-10 border-t border-white/10 pt-16 md:mt-24 md:grid-cols-[0.9fr_1.1fr] md:gap-16 md:pt-24">
          <Reveal>
            <div className="flex flex-col">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">/ Live from Instagram</span>
              <h3 className="mt-5 font-oswald text-4xl font-700 uppercase leading-[0.9] tracking-tighter text-white md:text-5xl">
                Straight from<br />the decks
              </h3>
              <p className="mt-6 max-w-sm text-sm leading-relaxed text-zinc-400">
                Follow <span className="text-white">@_jazzythegreat_</span> for the latest sets, behind-the-scenes reels and upcoming dates — updated in real time.
              </p>
              <a
                data-testid="instagram-embed-follow"
                href={BUSINESS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-8 inline-flex w-fit items-center gap-3 border border-white/20 px-6 py-3.5 hover:border-gold transition-colors duration-500"
              >
                <Instagram size={16} className="text-white group-hover:text-gold transition-colors duration-500" />
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-white group-hover:text-gold transition-colors duration-500">
                  View Profile
                </span>
              </a>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <InstagramEmbed />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
